export default "__VITE_ASSET__B_7C_7Uj__"